// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-divider {
  color: inherit;
  display: block;
  flex: 1 1 100%;
  height: 0px;
  max-height: 0px;
  opacity: var(--v-border-opacity);
  transition: inherit;
}
:where(.vuetify-styles) .v-divider {
  border-style: solid;
  border-width: thin 0 0 0;
}
:where(.vuetify-styles) .v-divider--vertical {
  align-self: stretch;
  border-width: 0 thin 0 0;
  display: inline-flex;
  height: auto;
  margin-left: -1px;
  max-height: 100%;
  max-width: 0px;
  vertical-align: text-bottom;
  width: 0px;
}
:where(.vuetify-styles) .v-divider--inset:not(.v-divider--vertical) {
  max-width: calc(100% - 72px);
  margin-inline-start: 72px;
}
:where(.vuetify-styles) .v-divider--inset.v-divider--vertical {
  margin-bottom: 8px;
  margin-top: 8px;
  max-height: calc(100% - 16px);
}
:where(.vuetify-styles) .v-divider--gradient {
  -webkit-mask-image: linear-gradient(90deg, transparent, #000, transparent);
          mask-image: linear-gradient(90deg, transparent, #000, transparent);
}
:where(.vuetify-styles) .v-divider--gradient.v-divider--vertical {
  -webkit-mask-image: linear-gradient(0deg, transparent, #000, transparent);
          mask-image: linear-gradient(0deg, transparent, #000, transparent);
}

:where(.vuetify-styles) .v-divider__content {
  padding: 0 16px;
  text-wrap: nowrap;
}
:where(.vuetify-styles) .v-divider__wrapper--vertical .v-divider__content {
  padding: 4px 0;
}

:where(.vuetify-styles) .v-divider__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
:where(.vuetify-styles) .v-divider__wrapper--vertical {
  flex-direction: column;
  height: 100%;
}
:where(.vuetify-styles) .v-divider__wrapper--vertical .v-divider {
  margin: 0 auto;
}
:where(.vuetify-styles) .v-divider__wrapper--gradient {
  -webkit-mask-image: linear-gradient(90deg, transparent, #000, transparent);
          mask-image: linear-gradient(90deg, transparent, #000, transparent);
}
:where(.vuetify-styles) .v-divider__wrapper--gradient.v-divider__wrapper--vertical {
  -webkit-mask-image: linear-gradient(0deg, transparent, #000, transparent);
          mask-image: linear-gradient(0deg, transparent, #000, transparent);
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VDivider/VDivider.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,cAAc;EACd,cAAc;EACd,WAAW;EACX,eAAe;EACf,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,2BAA2B;EAC3B,UAAU;AACZ;AACA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,0EAAkE;UAAlE,kEAAkE;AACpE;AACA;EACE,yEAAiE;UAAjE,iEAAiE;AACnE;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,0EAAkE;UAAlE,kEAAkE;AACpE;AACA;EACE,yEAAiE;UAAjE,iEAAiE;AACnE","sourcesContent":[".v-divider {\n  color: inherit;\n  display: block;\n  flex: 1 1 100%;\n  height: 0px;\n  max-height: 0px;\n  opacity: var(--v-border-opacity);\n  transition: inherit;\n}\n.v-divider {\n  border-style: solid;\n  border-width: thin 0 0 0;\n}\n.v-divider--vertical {\n  align-self: stretch;\n  border-width: 0 thin 0 0;\n  display: inline-flex;\n  height: auto;\n  margin-left: -1px;\n  max-height: 100%;\n  max-width: 0px;\n  vertical-align: text-bottom;\n  width: 0px;\n}\n.v-divider--inset:not(.v-divider--vertical) {\n  max-width: calc(100% - 72px);\n  margin-inline-start: 72px;\n}\n.v-divider--inset.v-divider--vertical {\n  margin-bottom: 8px;\n  margin-top: 8px;\n  max-height: calc(100% - 16px);\n}\n.v-divider--gradient {\n  mask-image: linear-gradient(90deg, transparent, #000, transparent);\n}\n.v-divider--gradient.v-divider--vertical {\n  mask-image: linear-gradient(0deg, transparent, #000, transparent);\n}\n\n.v-divider__content {\n  padding: 0 16px;\n  text-wrap: nowrap;\n}\n.v-divider__wrapper--vertical .v-divider__content {\n  padding: 4px 0;\n}\n\n.v-divider__wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.v-divider__wrapper--vertical {\n  flex-direction: column;\n  height: 100%;\n}\n.v-divider__wrapper--vertical .v-divider {\n  margin: 0 auto;\n}\n.v-divider__wrapper--gradient {\n  mask-image: linear-gradient(90deg, transparent, #000, transparent);\n}\n.v-divider__wrapper--gradient.v-divider__wrapper--vertical {\n  mask-image: linear-gradient(0deg, transparent, #000, transparent);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
